import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { unsafeUseFormReturnSubset } from '@ipfabric/ui-components/utils/formSnippets/unsafeUseFormReturnSubset';
import {
  type VendorsApiFieldValues,
  storedVendorsApi,
} from 'app/features/DiscoverySettingsForms/snippets/storedVendorsApi';
import { VendorsApi } from '../../../components/Authentication/VendorsApi';
import type { DiscoveryConfigWizardGroupDisplayControl } from '../DiscoveryConfigWizardPage1';

export const vendorsApiGroup = createFormSnippetGroup({
  snippets: {
    storedVendorsApi,
  },
  render: ({ renderSnippet, form }) => (
    <VendorsApi
      form={unsafeUseFormReturnSubset(form)<keyof VendorsApiFieldValues>()}
      renderSnippet={renderSnippet}
    />
  ),
  show: (control: DiscoveryConfigWizardGroupDisplayControl) => {
    control.setAuthenticationSubTab('vendors');
  },
});
